import { getProductById } from 'app/store/model/authUser/selectors/getProductById';

export const getPlanName = (
    productId: number
): string => {
    return getProductById(productId).pack.name;
};
